<section id="open-positions" class="py-5 bg-light">
    <div class="container">
        <h2 class="text-center mb-5">Open Positions</h2>
        <div class="row g-4">
            @for (job of jobs; track job.nnid) {
            <div class="col-md-4">
                <div class="card job-card p-3">
                    <h5 class="card-title">{{job.name}}</h5>
                    <div [innerHTML]="job.description"></div>
                    <a [routerLink]="['/jobs', job.slug]" class="btn btn-apply">More details</a>
                </div>
            </div>
            }
        </div>
    </div>
</section>
